module.exports = __webpack_public_path__ + "static/img/4.5f94046.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/6/1/sp/4.png
// module id = Whf2
// module chunks = 0